// extracted by mini-css-extract-plugin
export default {"content_wrapper":"NewAttachments_content_wrapper__pYi-2","label":"NewAttachments_label__ncX0Y"};